import { render, staticRenderFns } from "./openCaller.vue?vue&type=template&id=2fa0be75&scoped=true&"
import script from "./openCaller.vue?vue&type=script&lang=js&"
export * from "./openCaller.vue?vue&type=script&lang=js&"
import style0 from "./openCaller.vue?vue&type=style&index=0&id=2fa0be75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0be75",
  null
  
)

export default component.exports